import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Timer } from "lucide-react";

export const ScrapeSettings = ({ api }) => {
  const [val, setVal] = useState("");
  const [saved, setSaved] = useState("");

  useEffect(() => {
    axios.get(`${api}/scrape/settings`).then(({ data }) => {
      setVal(String(data.site_budget));
      setSaved(String(data.site_budget));
    }).catch(() => {});
  }, [api]);

  const save = async () => {
    if (val === saved) return;
    try {
      const { data } = await axios.put(`${api}/scrape/settings`, { site_budget: Number(val) });
      setSaved(String(data.site_budget));
      toast.success(`Tijd per website: ${data.site_budget} seconden`);
    } catch {
      toast.error("Kies een waarde tussen 15 en 600 seconden");
      setVal(saved);
    }
  };

  return (
    <label title="Maximale tijd die een diepe scrape per website krijgt. Daarna wordt opgeslagen wat gevonden is."
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 px-3 h-9 text-sm text-slate-600">
      <Timer className="w-4 h-4" strokeWidth={1.5} />
      Tijd per site
      <input data-testid="site-budget-input" type="number" min={15} max={600} value={val}
        onChange={(e) => setVal(e.target.value)} onBlur={save}
        onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
        className="w-14 bg-transparent text-right font-semibold tabular-nums outline-none focus:text-[#FF4500]" />
      s
    </label>
  );
};
